import { SxProps, Theme } from '@mui/material';

/** A customer that cannot become the customer of a process (not ACTIVE) stays listed but greyed out. */
export const processCreateAddCustomerBlockedRowStyles: SxProps<Theme> = {
  '& .MuiTableCell-root': { color: 'text.disabled' },
  bgcolor: 'action.hover',
};
